module.exports = __webpack_public_path__ + "static/img/h5banner1.f77b14be.png";